<template>
    <div>
        <div v-if="showOverview == true">
            <h2 class="title is-size-4">Further Education <button class="button is-small is-link" @click="addEducation()" :disabled="working==true">Add New</button></h2>
            <div class="notification is-warning" v-if="loading==true">Loading education ... </div>
            <div class="notification is-info" v-if="loading==false && education.length == 0">There are no education details to show. </div>
            <table class="table is-fullwidth is-hoverable" v-if="loading==false && education.length > 0">
                <thead>
                    <tr>
                        <th width="10">&nbsp;</th>
                        <th>Establishment</th>
                        <th>Course</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>&nbsp;</th>
                        <th style="">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in education" :key="row.id">
                        <td>
                            <span class="tag is-warning" title="Updated by Balmoral Staff" v-if="row.internal==1">B</span>
                        </td>
                        <td>{{ row.establishment}}</td>
                        <td>{{ row.course}}</td>
                        <td :title="row.start_date">{{ row.start_date_display}}</td>
                        <td :title="row.end_date">{{ row.end_date_display}}</td>
                        <td :title="'Updated on ' + row.date_added"><button class="is-small button is-success" @click="editEducation(row)" :disabled="working==true">Edit</button></td>
                        <td style=""><button class="is-small button is-danger" @click="deleteEducation(row)" :disabled="working==true">Delete</button></td>
                    </tr>
                    
                </tbody>
            </table>

            <h2 class="title is-size-4">Employment <button class="button is-small is-link" @click="addEmployment()" :disabled="working==true">Add New</button></h2>
            <div class="notification is-warning" v-if="loading_employment==true">Loading employment ... </div>
            <div class="notification is-info" v-if="loading_employment==false && employment.length == 0">There are no employment details to show. </div>
            <table class="table is-fullwidth is-hoverable" v-if="loading_employment==false && employment.length > 0">
                <thead>
                    <tr>
                        <th width="10">&nbsp;</th>
                        <th>Employer</th>
                        <th>Job Title</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Reason For Leaving</th>
                        <th>&nbsp;</th>
                        <th style="">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in employment" :key="row.id">
                         
                        <td>
                            <span class="tag is-warning" title="Updated by Balmoral Staff" v-if="row.internal==1">B</span>
                        </td>
                        <td>{{ row.employer_name}}</td>
                        <td>{{ row.job_title}}</td>
                        <td>{{ row.start_date_display}}</td>
                        <td>{{ row.end_date_display}}</td>
                        <td>{{ row.reason_for_leaving}}</td>
                        <td :title="'Updated on ' + row.date_added"><button class="is-small button is-success" @click="editEmployment(row)" :disabled="working==true">Edit</button></td>
                        <td style=""><button class="is-small button is-danger" @click="deleteEmployment(row)" :disabled="working==true">Delete</button></td>
                    </tr>
                    
                </tbody>
            </table>
        </div>

        <div v-if="showEducationForm==true">
            <h2 class="title">Edit Education Details</h2>
           
                <div class="field">
                    <label class="label">Establishment</label>
                    <div class="control">
                        <input class="input" type="text" v-model="selectedEducation.establishment" >
                    </div>
                </div>
                <div class="field">
                    <label class="label">Course</label>
                    <div class="control">
                        <input class="input" type="text" v-model="selectedEducation.course" >
                    </div>              
                </div>
                <div class="field">
                    <label class="label">Start Date</label>
                    <div class="control">
                        <input class="input" type="date" v-model="selectedEducation.start_date" >
                    </div>              
                </div>
                <div class="field">
                    <label class="label">End Date</label>
                    <div class="control">
                        <input class="input" type="date" v-model="selectedEducation.end_date" >
                    </div>              
                </div>
                <div class="field is-grouped">
                    <p class="control">
                        <button class="button is-success" @click="saveMemberEducation()">
                        Save Changes
                        </button>
                    </p>
                    <p class="control">
                        <a class="button is-light" @click="cancelEducation()">
                        Cancel and Discard Changes
                        </a>
                    </p>
                    </div>
           
        </div>

        <div v-if="showEmploymentForm==true">
            <h2 class="title">Edit Employment Details</h2>
           
                <div class="field">
                    <label class="label">Employer</label>
                    <div class="control">
                        <input class="input" type="text" v-model="selectedEmployment.employer_name" >
                    </div>
                </div>
                <div class="field">
                    <label class="label">Job Title</label>
                    <div class="control">
                        <input class="input" type="text" v-model="selectedEmployment.job_title" >
                    </div>              
                </div>
                <div class="field">
                    <label class="label">Start Date</label>
                    <div class="control">
                        <input class="input" type="date" v-model="selectedEmployment.date_from" >
                    </div>              
                </div>
                <div class="field">
                    <label class="label">End Date</label>
                    <div class="control">
                        <input class="input" type="date" v-model="selectedEmployment.date_to" >
                    </div>              
                </div>
                <div class="field">
                    <label class="label">Reason For Leaving</label>
                    <div class="control">
                        <input class="input" type="text" v-model="selectedEmployment.reason_for_leaving" >
                    </div>              
                </div>
                <div class="field is-grouped">
                    <p class="control">
                        <button class="button is-success" @click="saveMemberWorkExperience()">
                        Save Changes
                        </button>
                    </p>
                    <p class="control">
                        <a class="button is-light" @click="cancelEmployment()">
                        Cancel and Discard Changes
                        </a>
                    </p>
                    </div>
           
        </div>

    </div>
</template>

<script>
import MemberMixin from '@/mixins/MemberMixin.js';

import MemberService from '@/services/MemberService.js';
import UtilityService from '@/services/UtilityService.js';

export default {
    name: 'EmploymentHistory',
  data() {
    return {
      loading: true,
      working: false,
      loading_employment: false,
      education: [],
      employment: [],
      showOverview: true,
      showEducationForm: false,
      selectedEducation: [],
      showEmploymentForm: false,
      selectedEmployment: []
    }
  },
  mixins: [MemberMixin],
  props: ['member_id'],
  methods: {
        editEducation(row) {
            this.showOverview = false;
            this.showEducationForm = true

            this.selectedEducation = row;
        },
        addEducation() {
            this.showOverview = false;
            this.showEducationForm = true

            this.selectedEducation = [];
        },
        cancelEducation() {
            this.showOverview = true;
            this.showEducationForm = false

            this.selectedEducation = []
             this.getMemberEducation()
        },
         editEmployment(row) {
            this.showOverview = false;
            this.showEmploymentForm = true;

            this.selectedEmployment = row;
        },
        addEmployment() {
            this.showOverview = false;
            this.showEmploymentForm = true;

            this.selectedEmployment = [];
        },
        cancelEmployment() {
            this.showOverview = true;
            this.showEmploymentForm = false;

            this.selectedEmployment = []
             this.getMemberWorkExperience()
        },
       
        async getMemberEducation() {
            this.loading=true
            UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/education")
            .then(
                (education => {
                    this.$set(this, "education", education);
                    this.loading=false
                }).bind(this)
            );
        },

        async getMemberWorkExperience() {
            this.loading=true
            UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id + "/work_experience")
            .then(
                (employment => {
                    this.$set(this, "employment", employment);
                    this.loading=false
                }).bind(this)
            );
        },
        async saveMemberEducation() {
                this.working = true
                var formdata = { 
                   
                   member_id: this.member_id,
                   user_id: this.user_id,
                   establishment: this.selectedEducation.establishment,
                   course: this.selectedEducation.course,
                   start_date: this.selectedEducation.start_date,
                   end_date: this.selectedEducation.end_date,
                   
                   internal: 1,
                   previous_member_education_id: this.selectedEducation.id
                }; 

                MemberService.saveMemberEducation(this.accessToken, this.member_id, formdata)
                .then((response) => {
                    this.working = false
                    this.showOverview = true;
                    this.showEducationForm = false

                    this.selectedEducation = []
                    this.getMemberEducation()
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },
             async saveMemberWorkExperience() {
                this.working = true
                var formdata = { 
                   
                   member_id: this.member_id,
                   user_id: this.user_id,
                   employer_name: this.selectedEmployment.employer_name,
                   job_title: this.selectedEmployment.job_title,
                   date_from: this.selectedEmployment.date_from,
                   date_to: this.selectedEmployment.date_to,
                   reason_for_leaving: this.selectedEmployment.reason_for_leaving,
                   not_employed: this.selectedEmployment.not_employed,
                   address: this.selectedEmployment.address,
                   telephone: this.selectedEmployment.telephone,
                   roles_covered: this.selectedEmployment.roles_covered,
                   qualifications: this.selectedEmployment.qualifications,
                   internal: 1,
                   previous_member_work_experience_id: this.selectedEmployment.id
                }; 

                MemberService.saveMemberWorkExperience(this.accessToken, this.member_id, formdata)
                .then((response) => {
                    this.working = false
                    this.showOverview = true;
                    this.showEmploymentForm = false

                    this.selectedEmployment = []
                    this.getMemberWorkExperience()
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },

            async deleteEducation(row) {
                this.working = true
                if(confirm("Are you sure you want to delete this record ?"))
             {
                    var formdata = { 
                        member_id : row.member_id,
                        member_education_id: row.id
                    }; 

                    MemberService.deleteMemberEducation(this.accessToken, formdata)
                    .then((response) => {
                        this.selectedEducation = []
                        this.getMemberEducation()
                        console.log(response)
                        this.working = false
                        
                        }).catch((error) => {
                            if(error.response.status === 422)
                            {
                                console.log("Error:" + JSON.stringify(error.response.data));
                            }
                            alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                            this.working = false
                    });
                }
                else {
                    this.working = false;
                    return false
                }
            },
            async deleteEmployment(row) {
                this.working = true
                if(confirm("Are you sure you want to delete this record ?"))
             {
                    var formdata = { 
                        member_id : row.member_id,
                        member_work_experience_id: row.id
                    }; 

                    MemberService.deleteMemberWorkExperience(this.accessToken, formdata)
                    .then((response) => {
                        this.selectedEducation = []
                        this.getMemberWorkExperience()
                        console.log(response)
                        this.working = false
                        
                        }).catch((error) => {
                            if(error.response.status === 422)
                            {
                                console.log("Error:" + JSON.stringify(error.response.data));
                            }
                            alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                            this.working = false
                    });
                }
                else {
                    this.working = false;
                    return false
                }
            },
      
        
    },
    created() {
            this.getAccessToken()
            .then(() => { 
                this.getMemberEducation()
                this.getMemberWorkExperience();
            });
        
    },
    computed : {
       
    }
}
</script>